import { devWarn } from './devLogger';

// Errors that are permanent — retrying wastes quota and delays the user seeing a real error
const NON_RETRYABLE_CODES = new Set([
  'permission-denied',
  'not-found',
  'invalid-argument',
  'unauthenticated',
  'already-exists',
  'failed-precondition',
]);

export async function withRetry(operation, maxRetries = 3, backoffMs = 1000) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await operation();
    } catch (error) {
      // Don't retry permanent errors
      if (NON_RETRYABLE_CODES.has(error?.code)) throw error;
      if (attempt === maxRetries) throw error;

      // Exponential backoff with ±25% jitter to avoid thundering herd
      const jitter = 0.75 + Math.random() * 0.5;
      const delay = backoffMs * Math.pow(2, attempt - 1) * jitter;
      devWarn(`Operation failed (attempt ${attempt}/${maxRetries}), retrying in ${Math.round(delay)}ms:`, error.message);
      await new Promise(r => setTimeout(r, delay));
    }
  }
}
